import { useState } from "react";

const VmsSupportComponent = () => {
  const [issues] = useState([
    {
      id: 1,
      title: "Browser Compatibility Issue",
      description:
        "The VMS system is not rendering properly on older versions of Internet Explorer. Please use a modern browser like Chrome, Firefox, or Edge.",
    },
    {
      id: 2,
      title: "Slow Performance in Browser",
      description:
        "The system may perform slowly in browsers with a large number of open tabs. Close unnecessary tabs to improve performance.",
    },
    {
      id: 3,
      title: "Popup Blocker Blocking Features",
      description:
        "Certain features like appointment booking might not work if your browser's popup blocker is enabled. Disable popup blockers for the VMS site.",
    },
    {
      id: 4,
      title: "Cache Causing Errors",
      description:
        "Old cached data can sometimes cause issues. Clear your browser cache and cookies, then refresh the page.",
    },
    {
      id: 5,
      title: "Unsupported Extensions",
      description:
        "Some browser extensions may interfere with the VMS system. Try disabling extensions and reload the page to resolve the issue.",
    },
  ]);

  return (
    <div className="p-4 bg-gray-100 rounded-lg">
      <h2 className="text-xl font-semibold mb-4">VMS Browser-Related Issues</h2>
      <ul className="space-y-4">
        {issues.map((issue) => (
          <li key={issue.id} className="p-4 bg-white shadow rounded-lg">
            <h3 className="text-lg font-medium">{issue.title}</h3>
            <p className="text-sm text-gray-600">{issue.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default VmsSupportComponent;
